import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import {
//   LinkIcon,
// } from '../../components'
import Styles from './IyvListFilters.css'

/**
 * UI component for the List container.
 * All state management is done in List container.
 *
 * Renders a list of buttons, each representing an active filter.
 * Clicking an active filter calls a remove() func.
 *  
 */
@CSSModules(Styles, {allowMultiple:true})
export default class IyvListActiveFilters extends Component {
  static propTypes = {
    searchQuery: PropTypes.string,
    removeFilter: PropTypes.func,
    removeFilters: PropTypes.func,
    removeSearchFilter: PropTypes.func,
    selectedFilters: PropTypes.object,
    filterOptions: PropTypes.func,
    defaultFilter: PropTypes.string
  }
  //
  constructor(props) {
    super(props)
  }
  //
  // COMMON
  render() {
    const { selectedFilters, searchQuery, filterOptions, removeFilter,
            removeFilters, removeSearchFilter, defaultFilter } = this.props

    let idx = 0

    const renderActiveFilter = (label, remove) => {
      // create a <button> with custom label and custom remove method
      return (
        <button
          key={idx++}
          styleName='active-filter'
          onClick={remove}
          role='button'
          tabIndex='0'
        >
          <span>
            {label}
          </span>
          <span styleName='active-filter-remove' className='fa fa-remove'/>
        </button>
      )
    }

    // if there's a searchQuery, the first activeFilter is that query
    let activeFilters = searchQuery.trim() !== '' ?
      [renderActiveFilter(
        'Search: ' + searchQuery,
        removeSearchFilter
      )] :
      []

    activeFilters = activeFilters.concat(
      Object.entries(selectedFilters)
        .filter(
          (filter) => {
            // filter out any selected filters that are set to the default.
            // anything set to the default filter, is not going to have an
            // "active filter" elem.
            return filter[1] && filter[1] !== defaultFilter
          }
        )
        .map(
          (filter) => {
            // go through each of the remaining filters; these should have
            // "active filter" elements so they can be removed.

            // find the option that matches this active filter
            const option = filterOptions(filter[0])
              .find((o) => {
                return o.value + '' === filter[1] + ''
              })

            // if there is no option, don't create an "active filter" elem
            if (!option) {
              return null
            }

            // otherwise create an "active filter" elem, so it can be removed
            return renderActiveFilter(
              option.label,
              removeFilter(filter[0])
            )
          }
        )
        .filter(
          (filter) => {
            // remove anything that ended up as null somehow
            return filter !== null
          }
        )
    )

    // if there are no filters, just return a single "None" label
    if (activeFilters.length === 0) {
      return <div styleName='active-filters'>
        <div styleName='active-filters-label'>
          Active filters:
        </div>
        <div styleName='active-filter-none'>
          None
        </div>
      </div>
    }

    // otherwise, we have filters. Add a "clear filters" item to the list
    activeFilters = activeFilters.concat(
      [renderActiveFilter('Clear filters', removeFilters)]
    )

    // this is an array of <button>s with labels and remove methods
    return <div styleName='active-filters'>
      <div styleName='active-filters-label'>
        Active filters:
      </div>
      {
        activeFilters.map((e, i) => {
          return e
        })
      }
    </div>
  }
}
